


import store from '../index';
import { appInsights } from 'lib/appInsights';


var fetchUserActiveSchool = function (currentUser) {
	var currentStore = store.getState();

	// theese rules should only apply to the logged in user
	if (currentStore.user?.user?.localAccountId == currentUser.userId || currentStore.user?.currentUser?.userId == currentUser.userId) {
		// First check if school in localstorage, it could be saved from last session for the user to return to same school as last session
		var currentActiveSchoolId = validateSchoolId(currentUser, localStorage.getItem("hal.school" + currentUser.userId));
		if (currentActiveSchoolId != null && Number.isInteger(currentActiveSchoolId)) {
			if (currentStore?.user?.activeSchool != currentActiveSchoolId) {
				store.dispatch({ type: "SET_SCHOOL", payload: currentActiveSchoolId });
			}
			return currentActiveSchoolId;
		}
		// If not in store, could be multiple reasons why, no previous session in browser, security reasons, device reasons, cleared local data.
		// Check if user is returned and the active school has been set.
		currentActiveSchoolId = validateSchoolId(currentUser, currentStore?.user?.activeSchool);
		if (currentActiveSchoolId != null && Number.isInteger(currentActiveSchoolId)) {
			localStorage.setItem("hal.school" + currentUser.userId, currentActiveSchoolId);
			return currentActiveSchoolId;
		}

		// No active school set either in localstorage or in store. Chech user object if any schools and set first school in array as current.
		currentActiveSchoolId = currentStore?.user?.currentUser?.schools?.[0]?.id;
		if (currentActiveSchoolId != null && Number.isInteger(currentActiveSchoolId)) {
			localStorage.setItem("hal.school" + currentUser.userId, currentActiveSchoolId);
			store.dispatch({ type: "SET_SCHOOL", payload: currentActiveSchoolId });
			return currentActiveSchoolId;
		}
	}
}

var setSchoolOnUser = function (currentUser, currentActiveSchoolId) {
	if (currentActiveSchoolId != null && Number.isInteger(currentActiveSchoolId)) {
		localStorage.setItem("hal.school" + currentUser.userId, currentActiveSchoolId);
		store.dispatch({ type: "SET_SCHOOL", payload: currentActiveSchoolId });
	}
}

function validateSchoolId(currentUser, schoolId) {
	if (!currentUser?.schools || !schoolId) {
		return null;
	}
	const foundSchool = currentUser.schools.find(school => school.id == schoolId);

	if (!foundSchool) {
		const properties = {
			schoolId: schoolId,
			url: window.location.pathname,
		};

		appInsights.trackTrace({ message: 'Wrong school in localstorage', severityLevel: 2 }, properties);
	}

	return foundSchool?.id;
}

export default {
	fetchUserActiveSchool,
	setSchoolOnUser,
};
